import {
    useEffect, Dispatch, SetStateAction,
} from 'react'
import isEqual from 'lodash/isEqual'

/**
 * this hook is intended to apply values when external prop is changed
 */
export default function useSyncValues({
    value, data, setData, createEmptyDataRow, emptyRows,
}: {
    value: Record<string, any>[],
    data: Record<string, any>[],
    createEmptyDataRow: () => Record<string, any>,
    emptyRows: number,
    setData: Dispatch<SetStateAction<Record<string, any>>[]>,
}) {
    useEffect(() => {
        if (value && !isEqual(value, data)) {
            setData([
                ...value,
                ...Array.from(Array(emptyRows || 0), () => {
                    return createEmptyDataRow()
                }),
            ])
        }
    }, [value]) // eslint-disable-line react-hooks/exhaustive-deps
}
